import React from 'react';
import RichText from '../RichText';
import { StyledInfo, InfoContainer, InfoList } from './AccordionStyles';

export default function AdditionalInfo({ data, expandedAlways, isHighlighted, isRichTextValue }) {
  return (
    <InfoContainer>
      <InfoList data-test="info-list" $expandedAlways={expandedAlways} isHighlighted={isHighlighted}>
        {!data.value ? null : (
          <li key={data.id}>
            {isRichTextValue && data.value ? (
              <StyledInfo>
                <RichText document={data.value} />
              </StyledInfo>
            ) : data.value ? (
              <StyledInfo>{data.value}</StyledInfo>
            ) : null}
          </li>
        )}
      </InfoList>
    </InfoContainer>
  );
}
